export default __webpack_public_path__ + "static/media/set_4_360-3.ef691182.svg";